import { Component, Prop, Host, h, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';

@Component({
  tag: 'accordions-block',
  styleUrl: 'accordions-block.css',
  shadow: true,
})
export class AccordionsBlock {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * Text Orientation
   */
  @Prop() textOrientation: string;

  /**
   * Accordions Data
   */
  @Prop() accordionsData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  componentDidLoad() {
    this.initializeAccordion();
    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.accordion-container'),
      () => {
        this.el.shadowRoot.querySelector('.accordion-container').classList.add('animate');
      },
      ['.overlay1'],
    );
  }

  initializeAccordion() {
    const el = this.el.shadowRoot; // Access Shadow DOM
    const items = el.querySelectorAll('.accordion-dropdown-item');
  
    items.forEach((item) => {
      item.addEventListener('click', () => {
        // Toggle the open class on the clicked .accordion-dropdown-item
        item.classList.toggle('open');
      });
    });
  }

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }
  render() {
        const accordions = JSON.parse(this.accordionsData);
        //console.log('card', accordions);
    return (
      <Host>
        <div class={`container ${this.paddingBottom} ${this.paddingTop}`}>
          <div class={`accordion-container ${this.backgroundColor} ${this.textColor} ${this.textOrientation}`} style={{ backgroundImage: `url(${this.backgroundImage})` }}>
            <div class={`overlay1`}></div>
            <div class={`accordion-main-title`}>{this.mainTitle && <h2 class={`mb-40px fs-4 font-semibold text-ui-gray-1`}>{this.mainTitle}</h2>}</div>
            <ul class={`accordion-dropdowns`}>
              {accordions.length > 0 &&
                accordions &&
                accordions.map(accordion => (
                  <li class={`accordion-dropdown-item`}>
                    <div class={`accordion-dropdown-title-wrapper`}>
                      <h2 class={`accordion-dropdown-title`}>{accordion.title}</h2>
                    </div>
                    <ul class={`accordion-dropdown-inner ${accordion.image_url !== '' ? 'accordion-dropdown-columns' : ''}`}>
                      <div class={`accordion-dropdown-inner-copy`} innerHTML={accordion.description}></div>
                      {accordion.image_url && (
                        <div class={`h-screen w-1/2`}>
                          <image-block imageUrl={accordion.image_url} imageAlt={accordion.image_alt} imageClass={`accordion-dropdown-inner-image`}></image-block>
                        </div>
                      )}
                    </ul>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </Host>
    );
  }
}
